import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const verifyPublisherAction = createAsyncThunk(
    'verify-publisher',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/verify-publisher`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const verifyPublisherSlice = createSlice({
    name: 'verify-publisher',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(verifyPublisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(verifyPublisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(verifyPublisherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const verifyPublisherReducer = verifyPublisherSlice.reducer